export const ADD_TIMER = 'ADD_TIMER'
export const UPDATE_TIMER = 'UPDATE_TIMER'
export const EDIT_TIMER = 'EDIT_TIMER'
export const START_TIMER = 'START_TIMER'
export const PAUSE_TIMER = 'PAUSE_TIMER'
export const RESET_TIMER = 'RESET_TIMER'
export const DONE_TIMER = 'DONE_TIMER'
export const DELETE_TIMER = 'DELETE_TIMER'

export const PLAY_AUDIO = 'PLAY_AUDIO'
export const PAUSE_AUDIO = 'PAUSE_AUDIO'
